/**
 * @generated SignedSource<<0dc9acb71c38580035501289b07df412>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DetailedContactListItem_contact$data = {
  readonly __typename: string;
  readonly emailAddress: string | null | undefined;
  readonly familyName?: string;
  readonly givenName?: string;
  readonly id: string;
  readonly phoneNumber: string | null | undefined;
  readonly teamName?: string;
  readonly " $fragmentSpreads": FragmentRefs<"RemoveContactDialog_contact" | "UpdateContactRolesDialog_contact">;
  readonly " $fragmentType": "DetailedContactListItem_contact";
};
export type DetailedContactListItem_contact$key = {
  readonly " $data"?: DetailedContactListItem_contact$data;
  readonly " $fragmentSpreads": FragmentRefs<"DetailedContactListItem_contact">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DetailedContactListItem_contact",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "givenName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "familyName",
          "storageKey": null
        }
      ],
      "type": "PersonContact",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "teamName",
          "storageKey": null
        }
      ],
      "type": "TeamContact",
      "abstractKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "emailAddress",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "phoneNumber",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RemoveContactDialog_contact"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "UpdateContactRolesDialog_contact"
    }
  ],
  "type": "Contact",
  "abstractKey": "__isContact"
};

(node as any).hash = "9388a6bd279278871156ed876d47d85f";

export default node;
